import { z } from 'zod';

export const IsoDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD expected');

export const YearMonth = z
  .string()
  .regex(/^\d{4}-\d{2}$/, 'YYYY-MM expected');

export const PercentString = z
  .string()
  .regex(/^[+-]?\d+(\.\d+)?%$/, 'Pre-formatted percent like "+3.12%" expected');

export const HexColor = z
  .string()
  .regex(/^#[0-9a-fA-F]{6}$/, '#RRGGBB hex color expected');

export const AccentColor = z.enum(['amber', 'cyan', 'violet', 'rose', 'lime']);

export const Direction = z.enum(['up', 'down', 'flat']);

export const Tier = z.enum(['starter', 'pro', 'institutional']);

export const StrategyStatus = z.enum(['live', 'waitlist', 'paused']);
